import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, gbp, errMsg, STATUS_LABELS } from "@/lib/api";
import OrderCard from "@/pages/admin/OrderCard";

const FILTERS = [["", "All"], ["paid", "New"], ["shopping", "Shopping"], ["shipped", "Shipped"], ["delivered", "Delivered"], ["cancelled", "Cancelled"], ["awaiting_payment", "Unpaid"]];

export default function OrdersTab() {
  const [orders, setOrders] = useState([]);
  const [status, setStatus] = useState("");
  const [stats, setStats] = useState({});

  const load = () => {
    let live = true;
    api.get("/admin/orders", { params: status ? { status } : {} }).then((r) => live && setOrders(r.data));
    api.get("/admin/stats").then((r) => live && setStats(r.data));
    return () => { live = false; };
  };
  useEffect(load, [status]);

  const act = async (fn, msg) => {
    try { await fn(); toast.success(msg); load(); } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div className="mt-4">
      <div className="grid grid-cols-2 md:grid-cols-5 gap-3" data-testid="admin-stats">
        {["paid", "shopping", "shipped", "delivered", "cancelled"].map((s) => (
          <div key={s} className={`rounded-2xl p-4 ${s === "paid" ? "bg-[#8C2220] text-white" : "bg-white border border-[#EDE4D3]"}`}>
            <p className="text-xs opacity-75">{STATUS_LABELS[s]}</p>
            <p className="font-serif text-3xl font-bold" data-testid={`stat-${s}`}>{stats[s] ?? 0}</p>
          </div>
        ))}
      </div>
      <div className="mt-6 flex flex-wrap items-center gap-2">
        {FILTERS.map(([v, l]) => (
          <button key={v} onClick={() => setStatus(v)} className={`rounded-full px-4 py-1.5 text-sm border ${status === v ? "bg-[#0F172A] text-white" : "bg-white"}`} data-testid={`order-filter-${l.toLowerCase()}`}>{l}</button>
        ))}
        <button onClick={() => window.confirm("Delete all unpaid orders older than 24 hours? Customers who never finished paying are removed.") && act(async () => { const r = await api.post("/admin/orders/delete-unpaid"); toast.message(`${r.data.deleted} unpaid order(s) removed`); }, "Clean-up done")} className="ml-auto rounded-full px-4 py-1.5 text-sm border border-rose-300 text-rose-700 hover:bg-rose-50" data-testid="delete-unpaid-orders-button">Clear unpaid orders</button>
      </div>
      <div className="mt-6 space-y-4" data-testid="admin-order-list">
        {orders.length === 0 && <p className="text-slate-500 text-sm" data-testid="no-orders">No orders yet.</p>}
        {orders.map((o) => <OrderCard key={o.id} o={o} act={act} />)}
      </div>
      <p className="mt-6 text-xs text-slate-500">Totals shown in {gbp(0).slice(0, 1)} GBP. Refunds go back to the customer's card automatically.</p>
    </div>
  );
}
